import {
  GENDER_LIST_REQUEST,
  GENDER_LIST_SUCCESS,
  GENDER_LIST_FAIL
} from "../constants/application";

const initialState = {
  list: [],
  error: null,
  loading: false
};

export default function genderPreferenceReducer(state = initialState, action) {
  switch (action.type) {
    case GENDER_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GENDER_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
        error: null
      };
    case GENDER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}
